import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "~/lib/utils";

const searchBadgeVariants = cva("px-2 flex items-center gap-x-1 shrink-0 rounded-md body-sm-md", {
  variants: {
    variant: {
      polish:
        "text-token-polski-onContainer bg-token-polski-container border border-[0.4px] border-token-polski",
      math: "text-token-matematyka-onContainer bg-token-matematyka-container border border-[0.4px] border-token-matematyka",
      english:
        "text-token-angielski-onContainer bg-token-angielski-container border border-[0.4px] border-token-angielski",
      "7class": "text-violet-950 [&>div]:bg-violet-700 bg-violet-50",
      "8class": "bg-blue-50 text-blue-900 [&>div]:bg-blue-600",
      "8class-review": "text-yellow-990 bg-yellow-100 [&>div]:bg-yellow-400",
    },
  },
});

export interface SearchBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof searchBadgeVariants> {
  asChild?: boolean;
}

const getBadgeLabel = (variant: VariantProps<typeof searchBadgeVariants>["variant"]) => {
  switch (variant) {
    case "7class":
      return "7 klasa";
    case "8class":
      return "8 klasa";
    case "8class-review":
      return "Powtórka do E8";
    case "polish":
      return "Język Polski";
    case "math":
      return "Matematyka";
    case "english":
      return "Język Angielski";
    default:
      return "";
  }
};

const SearchBadge = React.forwardRef<HTMLDivElement, SearchBadgeProps>(
  ({ className, variant, ...props }, ref) => {
    const label = getBadgeLabel(variant);

    return (
      <div className={cn(searchBadgeVariants({ variant, className }))} ref={ref} {...props}>
        {variant === "7class" && <div className="size-1 rounded-full" />}
        {variant === "8class" && <div className="size-1 rounded-full" />}
        {variant === "8class-review" && <div className="size-1 rounded-full" />}
        {label}
      </div>
    );
  },
);
SearchBadge.displayName = "SearchBadge";

export { SearchBadge, searchBadgeVariants };
